import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-form-label" }
const _hoisted_2 = {
  key: 0,
  class: "p-form-label__label"
}
const _hoisted_3 = {
  key: 2,
  class: "p-form-label__addition"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconRequired = _resolveComponent("IconRequired")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.required)
      ? (_openBlock(), _createBlock(_component_IconRequired, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.$slots.addition)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "addition", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}